import * as React from "react";
import { Typography } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DateTimePicker } from "@mui/x-date-pickers";
import { FieldLabelWithHelp } from "./FieldHelpIcon";

import esLocale from "date-fns/locale/es";
import ptSaLocale from "date-fns/locale/pt-BR";
import enSaLocale from "date-fns/locale/en-US";

type ShowDateTimeProps = {
  label: string;
  value: Date | null;
  helperText?: string;
  showUTCTime?: boolean;
  hidden?: boolean;
  description?: string;
};

export const ShowDateTime: React.FC<ShowDateTimeProps> = ({
  label,
  value,
  showUTCTime = false,
  helperText = "",
  hidden = false,
  description,
}) => {
  if (hidden) return null;
  const locale = {
    es: esLocale,
    pt: ptSaLocale,
    en: enSaLocale,
  };

  let utcTime = "";
  if (value !== null) {
    try {
      utcTime = `UTC ${value.toISOString().substring(11, 16)}`;
    } catch (e) {
      utcTime = "";
    }
  }

  return (
    <LocalizationProvider
      adapterLocale={locale["es"]}
      dateAdapter={AdapterDateFns}
    >
      <div style={{ display: "flex" }}>
        <DateTimePicker
          label={<FieldLabelWithHelp label={label} description={description} />}
          value={value}
          onChange={() => {}}
          slotProps={{
            textField: {
              sx: { m: 1 },
              helperText: helperText,
              InputLabelProps: { shrink: true },
            },
          }}
        />
        {showUTCTime && (
          <Typography sx={{ display: "inline", pt: 2 }} variant={"h6"}>
            {utcTime}
          </Typography>
        )}
      </div>
    </LocalizationProvider>
  );
};
